import styled from 'styled-components';

export const ButtonContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.space.sm};
  ${({ isFeedbackButtonFixed, dialogConfig }) => (isFeedbackButtonFixed
    ? 'right: -1rem;'
    : `right:  ${dialogConfig.buttonsRight}`)}
`;
